<template lang="pug">
img.session-type-icon(
  :src="iconSrc"
  alt=""
  width="24"
  height="24"
  aria-hidden="true"
)
</template>

<script>
import { getNonSessionIconPath } from './scheduleResultGrouping.js';

export default {
  name: 'SessionTypeIcon',

  props: {
    sessionType: {
      type: String,
      required: true,
    },
  },

  computed: {
    iconSrc() {
      return getNonSessionIconPath(this.sessionType);
    },
  },
};
</script>

<style lang="scss" scoped>
.session-type-icon {
  display: block;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}
</style>
